import {useQuery} from 'react-query';
import {AtributyApi, DiscriminatorLayerVO} from '../api';
import {LayerId} from '@mc/react-mapio';

export const CACHE_KEY_DISCRIMINATOR_LAYERS = 'CACHE_KEY_DISCRIMINATOR_LAYERS';

export const useDiscriminatorLayers = (layerId: LayerId) => {
    return useQuery<DiscriminatorLayerVO[]>(
        [CACHE_KEY_DISCRIMINATOR_LAYERS, layerId],
        async () => (await AtributyApi.getDiscriminatorLayers(Number(layerId))).data,
        {
            enabled: Boolean(layerId),
            refetchOnWindowFocus: true,
            refetchOnReconnect: false,
            refetchOnMount: false,
        },
    );
};
